import React, { FC } from 'react';
import PageListItem from './PageListItem/PageListItem';
import { NavItem } from '../../../../../../interfaces/nav/NavMenu';
import { useTranslation } from 'gatsby-plugin-react-i18next';

interface Props {
  items: Array<NavItem>;
  currentPage: string;
}

const PagesList: FC<Props> = ({ items, currentPage }) => {
  const { t } = useTranslation();

  const pagesMapper = (item: NavItem, index: number) => (
    <PageListItem
      key={index}
      number={index}
      label={t(item.label)}
      title={t(item.title)}
      description={item.description && t(item.description)}
      url={t(item.url)}
    />
  );

  return (
    <div data-aos='fade-in' data-aos-delay='600'>
      {items.filter((item: NavItem) => t(item.label) !== currentPage).map(pagesMapper)}
    </div>
  );
};

export default PagesList;
